module.exports = {"TXTCLI_Apply__forChanges":{"id":"TXTCLI_Apply__forChanges","defaultMessage":"Tillämpa","flags":["TRACK"],"track":"Apply"}}